import {z} from 'zod'

export const EncryptionKey = z.string().length(32)
export type EncryptionKey = z.infer<typeof EncryptionKey>
